/* tslint:disable */
/* eslint-disable */
/**
 * Credify external API doc v2
 * API documentations for integration version 2.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIErrorV2 } from '../model';
// @ts-ignore
import { APISuccessEmpty } from '../model';
// @ts-ignore
import { GetOrderDisbursementDocLocationResponse } from '../model';
// @ts-ignore
import { IntegrationOrder } from '../model';
// @ts-ignore
import { OrderAcknowledgementRequest } from '../model';
// @ts-ignore
import { OrderApprovalRequest } from '../model';
// @ts-ignore
import { OrderCancellationRequest } from '../model';
// @ts-ignore
import { OrderCompletionRequest } from '../model';
// @ts-ignore
import { OrderRejectionRequest } from '../model';
// @ts-ignore
import { OrderSigningRequest } from '../model';
/**
 * BNPLProviderApi - axios parameter creator
 * @export
 */
export const BNPLProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This request acknowledges a BNPL order. 
         * @summary Acknowledge order
         * @param {string} orderId The id of an order
         * @param {OrderAcknowledgementRequest} orderAcknowledgementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeBnplOrder: async (orderId: string, orderAcknowledgementRequest: OrderAcknowledgementRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('acknowledgeBnplOrder', 'orderId', orderId)
            // verify required parameter 'orderAcknowledgementRequest' is not null or undefined
            assertParamExists('acknowledgeBnplOrder', 'orderAcknowledgementRequest', orderAcknowledgementRequest)
            const localVarPath = `/v2/integration/bnpl-provider/orders/{order_id}/acknowledge`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = orderAcknowledgementRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This request approves a BNPL order. 
         * @summary Approve order
         * @param {string} orderId The id of an order
         * @param {OrderApprovalRequest} orderApprovalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveBnplOrder: async (orderId: string, orderApprovalRequest: OrderApprovalRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('approveBnplOrder', 'orderId', orderId)
            // verify required parameter 'orderApprovalRequest' is not null or undefined
            assertParamExists('approveBnplOrder', 'orderApprovalRequest', orderApprovalRequest)
            const localVarPath = `/v2/integration/bnpl-provider/orders/{order_id}/approve`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = orderApprovalRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This requests cancel of a BNPL order. 
         * @summary Cancel order
         * @param {string} orderId The id of an order
         * @param {OrderCancellationRequest} orderCancellationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBnplOrder: async (orderId: string, orderCancellationRequest: OrderCancellationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cancelBnplOrder', 'orderId', orderId)
            // verify required parameter 'orderCancellationRequest' is not null or undefined
            assertParamExists('cancelBnplOrder', 'orderCancellationRequest', orderCancellationRequest)
            const localVarPath = `/v2/integration/bnpl-provider/orders/{order_id}/cancel`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = orderCancellationRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * When the payment is completed, the BNPL Provider needs to call this API to notify the Ecosystem. 
         * @summary Complete order
         * @param {string} orderId The id of an order
         * @param {OrderCompletionRequest} orderCompletionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeBnplOrder: async (orderId: string, orderCompletionRequest: OrderCompletionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('completeBnplOrder', 'orderId', orderId)
            // verify required parameter 'orderCompletionRequest' is not null or undefined
            assertParamExists('completeBnplOrder', 'orderCompletionRequest', orderCompletionRequest)
            const localVarPath = `/v2/integration/bnpl-provider/orders/{order_id}/complete`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = orderCompletionRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns list of requirement documents 
         * @summary Get order\'s requirement documents
         * @param {string} orderId The id of an order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBnplOrderRequirementDocProvider: async (orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getBnplOrderRequirementDocProvider', 'orderId', orderId)
            const localVarPath = `/v2/integration/bnpl-provider/orders/{order_id}/documents`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This requests reject of a BNPL order. 
         * @summary Reject order
         * @param {string} orderId The id of an order
         * @param {OrderRejectionRequest} orderRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectBnplOrder: async (orderId: string, orderRejectionRequest: OrderRejectionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('rejectBnplOrder', 'orderId', orderId)
            // verify required parameter 'orderRejectionRequest' is not null or undefined
            assertParamExists('rejectBnplOrder', 'orderRejectionRequest', orderRejectionRequest)
            const localVarPath = `/v2/integration/bnpl-provider/orders/{order_id}/reject`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = orderRejectionRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves BNPL order\'s information 
         * @summary Order retrieve
         * @param {string} orderId The id of an order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveOrder: async (orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('retrieveOrder', 'orderId', orderId)
            const localVarPath = `/v2/integration/bnpl-provider/orders/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This request signs a BNPL order. 
         * @summary Sign order
         * @param {string} orderId The id of an order
         * @param {OrderSigningRequest} orderSigningRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signBnplOrder: async (orderId: string, orderSigningRequest: OrderSigningRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('signBnplOrder', 'orderId', orderId)
            // verify required parameter 'orderSigningRequest' is not null or undefined
            assertParamExists('signBnplOrder', 'orderSigningRequest', orderSigningRequest)
            const localVarPath = `/v2/integration/bnpl-provider/orders/{order_id}/sign`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = orderSigningRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BNPLProviderApi - functional programming interface
 * @export
 */
export const BNPLProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BNPLProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * This request acknowledges a BNPL order. 
         * @summary Acknowledge order
         * @param {string} orderId The id of an order
         * @param {OrderAcknowledgementRequest} orderAcknowledgementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acknowledgeBnplOrder(orderId: string, orderAcknowledgementRequest: OrderAcknowledgementRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessEmpty>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acknowledgeBnplOrder(orderId, orderAcknowledgementRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This request approves a BNPL order. 
         * @summary Approve order
         * @param {string} orderId The id of an order
         * @param {OrderApprovalRequest} orderApprovalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveBnplOrder(orderId: string, orderApprovalRequest: OrderApprovalRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessEmpty>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveBnplOrder(orderId, orderApprovalRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This requests cancel of a BNPL order. 
         * @summary Cancel order
         * @param {string} orderId The id of an order
         * @param {OrderCancellationRequest} orderCancellationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelBnplOrder(orderId: string, orderCancellationRequest: OrderCancellationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessEmpty>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelBnplOrder(orderId, orderCancellationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * When the payment is completed, the BNPL Provider needs to call this API to notify the Ecosystem. 
         * @summary Complete order
         * @param {string} orderId The id of an order
         * @param {OrderCompletionRequest} orderCompletionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeBnplOrder(orderId: string, orderCompletionRequest: OrderCompletionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessEmpty>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeBnplOrder(orderId, orderCompletionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns list of requirement documents 
         * @summary Get order\'s requirement documents
         * @param {string} orderId The id of an order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBnplOrderRequirementDocProvider(orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderDisbursementDocLocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBnplOrderRequirementDocProvider(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This requests reject of a BNPL order. 
         * @summary Reject order
         * @param {string} orderId The id of an order
         * @param {OrderRejectionRequest} orderRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectBnplOrder(orderId: string, orderRejectionRequest: OrderRejectionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessEmpty>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectBnplOrder(orderId, orderRejectionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves BNPL order\'s information 
         * @summary Order retrieve
         * @param {string} orderId The id of an order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveOrder(orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveOrder(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This request signs a BNPL order. 
         * @summary Sign order
         * @param {string} orderId The id of an order
         * @param {OrderSigningRequest} orderSigningRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signBnplOrder(orderId: string, orderSigningRequest: OrderSigningRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessEmpty>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signBnplOrder(orderId, orderSigningRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BNPLProviderApi - factory interface
 * @export
 */
export const BNPLProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BNPLProviderApiFp(configuration)
    return {
        /**
         * This request acknowledges a BNPL order. 
         * @summary Acknowledge order
         * @param {string} orderId The id of an order
         * @param {OrderAcknowledgementRequest} orderAcknowledgementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeBnplOrder(orderId: string, orderAcknowledgementRequest: OrderAcknowledgementRequest, options?: any): AxiosPromise<APISuccessEmpty> {
            return localVarFp.acknowledgeBnplOrder(orderId, orderAcknowledgementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This request approves a BNPL order. 
         * @summary Approve order
         * @param {string} orderId The id of an order
         * @param {OrderApprovalRequest} orderApprovalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveBnplOrder(orderId: string, orderApprovalRequest: OrderApprovalRequest, options?: any): AxiosPromise<APISuccessEmpty> {
            return localVarFp.approveBnplOrder(orderId, orderApprovalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This requests cancel of a BNPL order. 
         * @summary Cancel order
         * @param {string} orderId The id of an order
         * @param {OrderCancellationRequest} orderCancellationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBnplOrder(orderId: string, orderCancellationRequest: OrderCancellationRequest, options?: any): AxiosPromise<APISuccessEmpty> {
            return localVarFp.cancelBnplOrder(orderId, orderCancellationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * When the payment is completed, the BNPL Provider needs to call this API to notify the Ecosystem. 
         * @summary Complete order
         * @param {string} orderId The id of an order
         * @param {OrderCompletionRequest} orderCompletionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeBnplOrder(orderId: string, orderCompletionRequest: OrderCompletionRequest, options?: any): AxiosPromise<APISuccessEmpty> {
            return localVarFp.completeBnplOrder(orderId, orderCompletionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns list of requirement documents 
         * @summary Get order\'s requirement documents
         * @param {string} orderId The id of an order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBnplOrderRequirementDocProvider(orderId: string, options?: any): AxiosPromise<GetOrderDisbursementDocLocationResponse> {
            return localVarFp.getBnplOrderRequirementDocProvider(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * This requests reject of a BNPL order. 
         * @summary Reject order
         * @param {string} orderId The id of an order
         * @param {OrderRejectionRequest} orderRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectBnplOrder(orderId: string, orderRejectionRequest: OrderRejectionRequest, options?: any): AxiosPromise<APISuccessEmpty> {
            return localVarFp.rejectBnplOrder(orderId, orderRejectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves BNPL order\'s information 
         * @summary Order retrieve
         * @param {string} orderId The id of an order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveOrder(orderId: string, options?: any): AxiosPromise<IntegrationOrder> {
            return localVarFp.retrieveOrder(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * This request signs a BNPL order. 
         * @summary Sign order
         * @param {string} orderId The id of an order
         * @param {OrderSigningRequest} orderSigningRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signBnplOrder(orderId: string, orderSigningRequest: OrderSigningRequest, options?: any): AxiosPromise<APISuccessEmpty> {
            return localVarFp.signBnplOrder(orderId, orderSigningRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BNPLProviderApi - interface
 * @export
 * @interface BNPLProviderApi
 */
export interface BNPLProviderApiInterface {
    /**
     * This request acknowledges a BNPL order. 
     * @summary Acknowledge order
     * @param {string} orderId The id of an order
     * @param {OrderAcknowledgementRequest} orderAcknowledgementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApiInterface
     */
    acknowledgeBnplOrder(orderId: string, orderAcknowledgementRequest: OrderAcknowledgementRequest, options?: AxiosRequestConfig): AxiosPromise<APISuccessEmpty>;

    /**
     * This request approves a BNPL order. 
     * @summary Approve order
     * @param {string} orderId The id of an order
     * @param {OrderApprovalRequest} orderApprovalRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApiInterface
     */
    approveBnplOrder(orderId: string, orderApprovalRequest: OrderApprovalRequest, options?: AxiosRequestConfig): AxiosPromise<APISuccessEmpty>;

    /**
     * This requests cancel of a BNPL order. 
     * @summary Cancel order
     * @param {string} orderId The id of an order
     * @param {OrderCancellationRequest} orderCancellationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApiInterface
     */
    cancelBnplOrder(orderId: string, orderCancellationRequest: OrderCancellationRequest, options?: AxiosRequestConfig): AxiosPromise<APISuccessEmpty>;

    /**
     * When the payment is completed, the BNPL Provider needs to call this API to notify the Ecosystem. 
     * @summary Complete order
     * @param {string} orderId The id of an order
     * @param {OrderCompletionRequest} orderCompletionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApiInterface
     */
    completeBnplOrder(orderId: string, orderCompletionRequest: OrderCompletionRequest, options?: AxiosRequestConfig): AxiosPromise<APISuccessEmpty>;

    /**
     * This returns list of requirement documents 
     * @summary Get order\'s requirement documents
     * @param {string} orderId The id of an order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApiInterface
     */
    getBnplOrderRequirementDocProvider(orderId: string, options?: AxiosRequestConfig): AxiosPromise<GetOrderDisbursementDocLocationResponse>;

    /**
     * This requests reject of a BNPL order. 
     * @summary Reject order
     * @param {string} orderId The id of an order
     * @param {OrderRejectionRequest} orderRejectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApiInterface
     */
    rejectBnplOrder(orderId: string, orderRejectionRequest: OrderRejectionRequest, options?: AxiosRequestConfig): AxiosPromise<APISuccessEmpty>;

    /**
     * This retrieves BNPL order\'s information 
     * @summary Order retrieve
     * @param {string} orderId The id of an order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApiInterface
     */
    retrieveOrder(orderId: string, options?: AxiosRequestConfig): AxiosPromise<IntegrationOrder>;

    /**
     * This request signs a BNPL order. 
     * @summary Sign order
     * @param {string} orderId The id of an order
     * @param {OrderSigningRequest} orderSigningRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApiInterface
     */
    signBnplOrder(orderId: string, orderSigningRequest: OrderSigningRequest, options?: AxiosRequestConfig): AxiosPromise<APISuccessEmpty>;

}

/**
 * BNPLProviderApi - object-oriented interface
 * @export
 * @class BNPLProviderApi
 * @extends {BaseAPI}
 */
export class BNPLProviderApi extends BaseAPI implements BNPLProviderApiInterface {
    /**
     * This request acknowledges a BNPL order. 
     * @summary Acknowledge order
     * @param {string} orderId The id of an order
     * @param {OrderAcknowledgementRequest} orderAcknowledgementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApi
     */
    public acknowledgeBnplOrder(orderId: string, orderAcknowledgementRequest: OrderAcknowledgementRequest, options?: AxiosRequestConfig) {
        return BNPLProviderApiFp(this.configuration).acknowledgeBnplOrder(orderId, orderAcknowledgementRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This request approves a BNPL order. 
     * @summary Approve order
     * @param {string} orderId The id of an order
     * @param {OrderApprovalRequest} orderApprovalRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApi
     */
    public approveBnplOrder(orderId: string, orderApprovalRequest: OrderApprovalRequest, options?: AxiosRequestConfig) {
        return BNPLProviderApiFp(this.configuration).approveBnplOrder(orderId, orderApprovalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This requests cancel of a BNPL order. 
     * @summary Cancel order
     * @param {string} orderId The id of an order
     * @param {OrderCancellationRequest} orderCancellationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApi
     */
    public cancelBnplOrder(orderId: string, orderCancellationRequest: OrderCancellationRequest, options?: AxiosRequestConfig) {
        return BNPLProviderApiFp(this.configuration).cancelBnplOrder(orderId, orderCancellationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * When the payment is completed, the BNPL Provider needs to call this API to notify the Ecosystem. 
     * @summary Complete order
     * @param {string} orderId The id of an order
     * @param {OrderCompletionRequest} orderCompletionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApi
     */
    public completeBnplOrder(orderId: string, orderCompletionRequest: OrderCompletionRequest, options?: AxiosRequestConfig) {
        return BNPLProviderApiFp(this.configuration).completeBnplOrder(orderId, orderCompletionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns list of requirement documents 
     * @summary Get order\'s requirement documents
     * @param {string} orderId The id of an order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApi
     */
    public getBnplOrderRequirementDocProvider(orderId: string, options?: AxiosRequestConfig) {
        return BNPLProviderApiFp(this.configuration).getBnplOrderRequirementDocProvider(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This requests reject of a BNPL order. 
     * @summary Reject order
     * @param {string} orderId The id of an order
     * @param {OrderRejectionRequest} orderRejectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApi
     */
    public rejectBnplOrder(orderId: string, orderRejectionRequest: OrderRejectionRequest, options?: AxiosRequestConfig) {
        return BNPLProviderApiFp(this.configuration).rejectBnplOrder(orderId, orderRejectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves BNPL order\'s information 
     * @summary Order retrieve
     * @param {string} orderId The id of an order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApi
     */
    public retrieveOrder(orderId: string, options?: AxiosRequestConfig) {
        return BNPLProviderApiFp(this.configuration).retrieveOrder(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This request signs a BNPL order. 
     * @summary Sign order
     * @param {string} orderId The id of an order
     * @param {OrderSigningRequest} orderSigningRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLProviderApi
     */
    public signBnplOrder(orderId: string, orderSigningRequest: OrderSigningRequest, options?: AxiosRequestConfig) {
        return BNPLProviderApiFp(this.configuration).signBnplOrder(orderId, orderSigningRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
